import { render, staticRenderFns } from "./areauser.vue?vue&type=template&id=59a830a6&scoped=true&"
import script from "./areauser.vue?vue&type=script&lang=js&"
export * from "./areauser.vue?vue&type=script&lang=js&"
import style0 from "./areauser.vue?vue&type=style&index=0&id=59a830a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a830a6",
  null
  
)

export default component.exports